module.exports = __webpack_public_path__ + "img/vintage.915f07f.webp";